import { useState, useCallback, useEffect } from 'react';
import { Modal } from '@poplar/components/Modal';
import { getBgColorForStep, Step, EducationModalBody } from './index';
import { useUser } from '@poplar/hooks/useUser';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { theme } from '@yoweb/ui/styles';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * A single step of the EducationModal specifically for showing the new recurring todo functionality.
 */
export var RecurringTodoStep = function RecurringTodoStep(_ref) {
  var _profile$onboardingSt, _profile$onboardingSt2;

  var onModalClose = _ref.onModalClose;

  var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated,
      profile = _useUser.profile;

  var _useExternalConfig = useExternalConfig(),
      enableRecuringTodos = _useExternalConfig.globalFeatures.enableRecuringTodos;

  var _useState = useState(false),
      isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _useState2 = useState(false),
      isModalDismissed = _useState2[0],
      setIsModalDismissed = _useState2[1];

  var shouldOpenModal = enableRecuringTodos && !isModalDismissed && isAuthenticated && (profile === null || profile === void 0 ? void 0 : (_profile$onboardingSt = profile.onboardingStatus) === null || _profile$onboardingSt === void 0 ? void 0 : _profile$onboardingSt.isPoplarEducationalModalDisplayed) && !(profile !== null && profile !== void 0 && (_profile$onboardingSt2 = profile.onboardingStatus) !== null && _profile$onboardingSt2 !== void 0 && _profile$onboardingSt2.isRecurringTaskModalDisplayed);
  var handleDismissModal = useCallback(function () {
    setIsModalDismissed(true);
    setIsModalOpen(false);
    onModalClose();
  }, [onModalClose]);
  useEffect(function () {
    if (shouldOpenModal) {
      // need to wait for some time to show the modal, as we have a bug where
      // the page scroll bar doesn't get hidden correctly if this is called too early
      setTimeout(function () {
        return setIsModalOpen(true);
      }, theme.transitionDuration.visual);
    }
  }, [shouldOpenModal]);
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isModalOpen,
    onClose: function onClose() {
      return handleDismissModal();
    },
    bgColor: getBgColorForStep(Step.RECURRING_TODOS),
    testId: "recurring-todo-step-modal",
    hasCloseButton: true,
    children: /*#__PURE__*/_jsx(EducationModalBody, {
      step: Step.RECURRING_TODOS
    })
  });
};